"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var fields = _interopRequireWildcard(require("./fields"));

var _submitButton = _interopRequireDefault(require("./submitButton"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _feedback = _interopRequireDefault(require("./fields/subComponents/feedback"));

var _hint = _interopRequireDefault(require("./fields/subComponents/hint"));

var _fieldLabel = _interopRequireDefault(require("./fields/subComponents/fieldLabel"));

var _required = _interopRequireDefault(require("./fields/subComponents/required"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));
    _this.state = {
      fieldsValidity: {}
    };
    _this.isValid = _this.isValid.bind(_assertThisInitialized(_this));
    _this.onFieldValidationChange = _this.onFieldValidationChange.bind(_assertThisInitialized(_this));
    _this.checkValidity = _this.checkValidity.bind(_assertThisInitialized(_this));
    _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
    _this.addValidationToFields = _this.addValidationToFields.bind(_assertThisInitialized(_this));
    _this.addFieldValidation = _this.addFieldValidation.bind(_assertThisInitialized(_this));
    _this.uid = props.id;
    return _this;
  }

  _createClass(Form, [{
    key: "isValid",
    value: function isValid() {
      return Object.values(this.state.fieldsValidity).reduce(function (valid, v) {
        return valid && v;
      }, true);
    }
  }, {
    key: "onFieldValidationChange",
    value: function onFieldValidationChange(validationId, isFieldValid) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fieldsValidity: _objectSpread({}, prevState.fieldsValidity, _defineProperty({}, validationId, isFieldValid || false))
        });
      }, this.checkValidity);
    }
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var onValidationChange = this.props.onValidationChange;
      var isValid = this.isValid();

      if (onValidationChange) {
        onValidationChange(isValid);
      }
    }
  }, {
    key: "submitForm",
    value: function submitForm(event) {
      event.preventDefault();

      if (this.isValid()) {
        this.props.onSubmit();
      }
    }
  }, {
    key: "addValidationToFields",
    value: function addValidationToFields(children) {
      if (_react.default.Children.count(children) > 1) {
        return _react.default.Children.map(children, this.addFieldValidation);
      } else {
        return this.addFieldValidation(children);
      }
    }
  }, {
    key: "addFieldValidation",
    value: function addFieldValidation(child) {
      var fieldTypes = Object.values(fields);

      var _ref = child || {},
          _ref$props = _ref.props,
          props = _ref$props === void 0 ? false : _ref$props;

      if (child && fieldTypes.includes(child.type)) {
        return _react.default.cloneElement(child, {
          onValidationChange: this.onFieldValidationChange,
          renderValidationOnMount: this.props.renderValidationOnMount
        });
      } else if (props && props.children) {
        return _react.default.cloneElement(child, {
          children: this.addValidationToFields(props.children)
        });
      } else {
        return child;
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var children = this.props.children;
      return this.addValidationToFields(children);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("form", _extends({
        id: this.uid,
        noValidate: true,
        className: "co-form"
      }, (0, _getNativeProps.default)(this.props), {
        onSubmit: this.submitForm
      }), this.renderChildren());
    }
  }]);

  return Form;
}(_react.default.Component);

var noop = function noop() {
  return true;
};

Form.defaultProps = {
  onSubmit: noop,
  onValidationChange: function onValidationChange() {
    return true;
  }
};
Form.propTypes = {
  children: _propTypes.node.isRequired,
  id: _propTypes.string,
  onSubmit: _propTypes.func,
  onValidationChange: _propTypes.func,
  renderValidationOnMount: _propTypes.bool
};
Form.Field = fields.Field;
Form.EmailField = fields.EmailField;
Form.FieldGroup = fields.FieldGroup;
Form.InputGroup = fields.InputGroup;
Form.SubmitButton = _submitButton.default;
Form.FieldStateless = fields.FieldStateless;
Form.Feedback = _feedback.default;
Form.Hint = _hint.default;
Form.Label = _fieldLabel.default;
Form.Required = _required.default;
var _default = Form;
exports.default = _default;
Form.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "isValid",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onFieldValidationChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "validationId",
      "type": null
    }, {
      "name": "isFieldValid",
      "type": null
    }],
    "returns": null
  }, {
    "name": "checkValidity",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "submitForm",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addValidationToFields",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addFieldValidation",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderChildren",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Form",
  "props": {
    "onSubmit": {
      "defaultValue": {
        "value": "() => true",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onValidationChange": {
      "defaultValue": {
        "value": "() => true",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "renderValidationOnMount": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};